import React from "react";
import { Link } from "react-router-dom";





const Breadcrumb = ({ items = [] }) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <nav className="flex items-center flex-wrap gap-2 text-sm">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.link ? (
            <Link
              to={item.link}
              className="text-gray-500 hover:text-red-600"
            >
              {item.label}
            </Link>
          ) : (
            <span className="font-semibold text-red-600" style={{color:"#CB1100"}}> 
              {item.label}
            </span>
          )}

          {index !== items.length - 1 && (
            <span className="text-gray-400"> / </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;